import React, { useEffect } from "react";
import { useAppSelector } from "store/store.tsx";
import { selectIsVersionOutOfDate } from "store/slices/versionSlice.ts";

export const RequireVersionRefresh = ({
  children,
}: React.PropsWithChildren) => {
  const isOutOfDate = useAppSelector(selectIsVersionOutOfDate);
  useEffect(() => {
    if (isOutOfDate) {
      window.location.reload();
    }
  }, [isOutOfDate]);
  return children;
};
